import { render, staticRenderFns } from "./org_profile.vue?vue&type=template&id=356f4778&scoped=true&"
import script from "./org_profile.vue?vue&type=script&lang=js&"
export * from "./org_profile.vue?vue&type=script&lang=js&"
import style0 from "./org_profile.vue?vue&type=style&index=0&id=356f4778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f4778",
  null
  
)

export default component.exports